"use client";

import { m, useScroll, useMotionValueEvent } from "framer-motion";
import { useState } from "react";

export default function ScrollToTop() {
  const { scrollYProgress } = useScroll();
  const [show, setShow] = useState(false);

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    setShow(v > 0.3);
  });

  return (
    <m.button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: show ? 1 : 0, scale: show ? 1 : 0.8 }}
      /* --mobile-cta-h is the height of the fixed mobile trial banner (0 when
         it's absent), so this button always sits clear of it. */
      className="fixed bottom-[calc(1.5rem+var(--mobile-cta-h,0px))] right-6 z-50 w-10 h-10 bg-white border border-black/[0.06] rounded-full shadow-lg flex items-center justify-center text-black/40 hover:text-black hover:border-black/20 transition-colors"
      aria-label="Scroll to top"
    >
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18" />
      </svg>
    </m.button>
  );
}
